<div ngForm="ewCustomFieldsForm">
	<div *ngFor="let field of value; trackBy: trackById; let index = index">
		<div [ngModelGroup]="'customFieldsGroup' + index">
			<div [ngSwitch]="field.fieldType">
				<vb-ui-horizontal-form-group *ngSwitchCase="'Text'">
					<label for="textField" #uiLabel>{{ field.name }}</label>
					<input uiControl class="form-control" id="textField" type="text" name="textField" [required]="field.required" [(ngModel)]="field.value" (ngModelChange)="onCustomFieldChanged()" #textField="ngModel" trim="blur"/>

					<div *ngIf="textField.invalid" role="alert" vbUiErrorMessage uiValidation>
						@if (textField.errors.required) {
							{{ 'ThisFieldIsRequired' | translate }}
						}
					</div>
				</vb-ui-horizontal-form-group>

				<vb-ui-horizontal-form-group *ngSwitchCase="'Select'">
					<label for="selectField" #uiLabel>{{field.name}}</label>
					<select uiControl class="form-select" id="selectField" name="selectField" [(ngModel)]="field.value" (ngModelChange)="onCustomFieldChanged()" [required]="field.required">
						<option *ngIf="!field.required" [ngValue]=""></option>
						<option *ngFor="let option of field.options" [ngValue]="option">
							{{ option }}
						</option>
					</select>
				</vb-ui-horizontal-form-group>
			</div>
		</div>
	</div>
</div>

